/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: ba-ui-common (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import PropTypes from 'prop-types';

import React, { Component } from 'react';

import { Button } from '@waca/ca-ui-toolkit';
import stringResource from 'ba-filter-nls';

import './ApplyButton.scss';
/*
Render a full width 'Apply' button which is used by all the compact filters.
*/
export default class ApplyButton extends Component<any, any> {
	// Define properties and types
	static propTypes = {
		dirty: PropTypes.bool.isRequired,
		onApply: PropTypes.func.isRequired,
		loading: PropTypes.bool.isRequired,
		readOnly: PropTypes.bool.isRequired,
	};

	render() {
		const { dirty, onApply, loading, readOnly } = this.props;

		return (
			<Button
				data-tid="applyClickable"
				fullWidth
				title={stringResource.get('apply')}
				aria-label={stringResource.get('apply')}
				intent={dirty ? 'primary' : 'secondary'}
				size="small"
				onClick={onApply}
				disabled={loading || readOnly || !dirty}
			>
				{stringResource.get('apply')}
			</Button>
		);
	}
}
